import React, {useContext} from "react"
import {Tooltip} from 'antd'
import {LayoutContext} from "./layouts/Default/LayoutContext";


const TooltipApp = ({children, className, classNames, ...props}) => {
  const {isLg} = useContext(LayoutContext)

  if (!isLg) {
    return (
      <span {...props} className={className}>
        {children}
      </span>
    )
  }
  return (
    <Tooltip className={className} {...props} >
      {children}
    </Tooltip>
  )
}
export default TooltipApp
